import styled, { css } from 'styled-components';

import { rem } from 'styles';
import { shouldForwardProp } from 'utils';

export const StyledPaper = styled.div.withConfig({ shouldForwardProp })`
  ${({ theme, padding }) => {
    const paddingStyle = {
      1: rem(theme.spacing[6]),
      2: rem(theme.spacing[8]),
      3: rem([theme.spacing[10], theme.spacing[8]]),
      4: rem([theme.spacing[11], theme.spacing[8]])
    };

    return [
      css`
        position: relative;
        border-radius: ${rem(theme.radius[1])};
        background: ${theme.colors.nature.n0};
        box-shadow: ${theme.shadows()[0]};
      `,
      padding && `padding: ${paddingStyle[padding]};`
    ];
  }}
`;
export const CloseButton = styled.button`
  position: absolute;
  top: ${rem(8)};
  right: ${rem(8)};
  background: transparent;
  border: none;
  font-size: ${rem(20)};
  cursor: pointer;
  color: ${({ theme }) => theme.colors.nature.n5};

  &:hover {
    color: ${({ theme }) => theme.colors.nature.n5};
  }
`;
